/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Revoked_DescriptionInputs */

const en_agent_authorization_revoked_description = /** @type {(inputs: Agent_Authorization_Revoked_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The project token is no longer valid. The existing directory listing is unchanged.`)
};

const zh_agent_authorization_revoked_description = /** @type {(inputs: Agent_Authorization_Revoked_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目 token 已失效，现有目录条目不会被删除。`)
};

/**
* | output |
* | --- |
* | "The project token is no longer valid. The existing directory listing is unchanged." |
*
* @param {Agent_Authorization_Revoked_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_revoked_description = /** @type {((inputs?: Agent_Authorization_Revoked_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Revoked_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_revoked_description(inputs)
	return zh_agent_authorization_revoked_description(inputs)
});
export { agent_authorization_revoked_description as "agent.authorization.revoked_description" }